module.exports = __webpack_public_path__ + "280c0b6c865820a6478ff842af43117a.svg";


//////////////////
// WEBPACK FOOTER
// ../images/sponsors/icelandair.svg
// module id = 408
// module chunks = 0